import { Modal } from "react-bootstrap";
import {
  SubmitButton,
  intlShape,
  apiShape,
  notifierShape,
  browserShape,
  withBrowser,
  withApi,
  withIntl,
  withNotifier,
  BadRequestError,
} from "lcm-iot-commons";

type Props = {
  onDecline: $TSFixMeFunction;
  onClose: $TSFixMeFunction;
  params: {
    id?: string;
    documentId?: string;
    model?: string;
  };
  intl: intlShape;
  notifier: notifierShape;
  browser: browserShape;
  api: apiShape;
  values: {
    attachments?: $TSFixMe;
    version?: string;
    language?: {
      code?: string;
      name?: string;
    };
    contentDate?: string;
    fileUpload?: {
      acceptedFiles?: $TSFixMe;
    };
  };
};

export function AttachmentOverrideModal({
  intl,
  values,
  onDecline,
  onClose,
  api,
  params,
  notifier,
  browser,
}: Props) {
  const onAccept = async () => {
    const attachment = values.attachments.find(
      // @ts-expect-error TS(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
      (item) =>
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        (item as $TSFixMe).languages.includes(values.language.code) &&
        (item as $TSFixMe).content_version === values.version,
    );
    if (attachment) {
      try {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const file = values.fileUpload.acceptedFiles[0];
        let uploadParams = {};
        if (values.contentDate) {
          uploadParams = { content_date: values.contentDate };
        }
        if (values.version) {
          uploadParams = { ...uploadParams, content_version: values.version };
        }
        uploadParams = {
          ...uploadParams,
          document_id: params.documentId,
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          languages: [values.language.code],
          file,
        };
        await api.upload(
          `/attachments/${(attachment as $TSFixMe).id}`,
          uploadParams,
        );
        notifier.showSuccess(
          intl.formatMessage({ id: "attachment_override.override_successful" }),
        );
        browser.navigateTo(`/${params.model}/${params.id}`);
      } catch (error) {
        if (error instanceof BadRequestError) {
          onClose(error);
        } else {
          notifier.showError(api.translateError(error));
          onClose(null);
        }
      }
    } else {
      notifier.showError(
        intl.formatMessage({
          id: "attachment_override.not_found_corresponding_attachment",
        }),
      );
      browser.navigateTo(`/${params.model}/${params.id}`);
    }
  };

  return (
    <Modal
      id="attachment-override-modal"
      show
      onHide={onClose}
      restoreFocus={false}
      backdrop={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({ id: "attachment_override.modal_title" })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {intl.formatMessage(
          { id: "attachment_override.modal_message" },
          { language: values.language?.name, version: values.version || "-" },
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className="btn-group">
            <SubmitButton
              id="attachment-override-confirm"
              onClick={onAccept}
              text={intl.formatMessage({ id: "button.confirm" })}
            />
            <button
              id="attachment-override-cancel"
              type="button"
              className="btn btn-default"
              onClick={onDecline}
            >
              {intl.formatMessage({ id: "attachment_override.cancel" })}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default withBrowser(
  withApi(withIntl(withNotifier(AttachmentOverrideModal))),
);
